import Configuration from '../config/Configuration.js';
import keycloak from '../helpers/Keycloak.js';
import { authHeader, authHeaderSet } from '../helpers/auth-header.js';

class AuthenticationService {

    constructor() {
        this.config = new Configuration();
        this.activeUser = null;
        this.userType = null;
    }

    async whoAmI() {
        try {
            const response = await fetch(this.config.WHOAMI_URL, {
                method: 'GET',
                headers: authHeader()
            });

            if (!response.ok) {
                return null;
            }

            const profileResponse = await response.json();
            this.userType = profileResponse.profile;
            return profileResponse;
        } catch (error) {
            console.error("❌ Error retrieving profile:", error);
            return null;
        }
    }

    async retrieveMyPractitionerProfile() {
        try {
            const response = await fetch(this.config.PRACTITIONERROLES_URL + "/self", {
                method: 'GET',
                headers: authHeader()
            });

            if (!response.ok) {
                return null;
            }

            const practitionerRole = await response.json();
            this.activeUser = practitionerRole;
            return practitionerRole;
        } catch (error) {
            console.error("❌ Error retrieving profile:", error);
            return null;
        }
    }

    async retrieveMyPatientProfile(uuid) {
        try {
            const response = await fetch(this.config.PATIENTS_URL + "/" + uuid, {
                method: 'GET',
                headers: authHeader()
            });

            if (!response.ok) {
                return null;
            }

            const patient = await response.json();
            this.activeUser = patient;
            return patient;
        } catch (error) {
            console.error("❌ Error retrieving profile:", error);
            return null;
        }
    }

    async init(loginCallback) {
        try {
            if (keycloak.authenticated) {
                const profileResponse = await this.whoAmI();
                if (loginCallback) {
                    if (profileResponse.profile === "practitioner") {
                        const practitionerProfile = await this.retrieveMyPractitionerProfile();
                        loginCallback(!!practitionerProfile);
                    } else {
                        const patientProfile = await this.retrieveMyPatientProfile(profileResponse.uuid);
                        loginCallback(!!patientProfile);
                    }
                }
            } else {
                if (loginCallback) {
                    loginCallback(false);
                }
            }
        } catch (error) {
            console.error("❌ Login failed:", error);
            if (loginCallback) {
                loginCallback(false);
            }
        }
    }

    logout() {
        keycloak.logout();
    }

    isAuthenticated() {
        return keycloak.authenticated;
    }

    getActiveUser() {
        return this.activeUser;
    }

    getUserType() {
        return this.userType;
    }

}

export default AuthenticationService;